import { STEP_NEXT, STEP_BACK, GOTO_STEP } from "../actions/stepper";
import {
  CHECK_ERROR_IN_CURRENT_STEP,
  PICKUP_FROM_SUBMISSION,
  SET_ADDRESS_TO_PICKUPFORM,
  SET_CURRENT_STEP_ERROR
} from "../actions/pickupForm";
import { SET_ADDRESS_ERRORS } from "../actions/address";

import steps from "../../containers/PickupForm/stepsMap";
import mapObject from "../../utils/mapObject";

const minStepIndex = 0;

// this middleware care only for stepper actions.
export const stepperMdl = ({ dispatch, getState }) => next => action => {
  next(action);

  if (
    action.type === STEP_NEXT ||
    action.type === STEP_BACK ||
    action.type === CHECK_ERROR_IN_CURRENT_STEP
  ) {
    const prevState = getState();
    const currentStepIndex = prevState.stepper.activeStepIndex;
    const addressError = prevState.address.geoSuggestAddress.isPartialMatch;
    const addressEditFlag = prevState.address.addressEditFlag;
    const force = action.payload ? action.payload.force : false;
    let nextStepIndex = currentStepIndex;
    let checkValidation = false;
    const maxStepIndex = prevState.lot.totalSteps - 1;
    let sellerType = prevState.lot.sellerType
    if (action.type === CHECK_ERROR_IN_CURRENT_STEP) {
      if (checkRequiredFields(currentStepIndex, prevState, dispatch)) {
        dispatch({ type: SET_CURRENT_STEP_ERROR, payload: false });
        //set step error to false
      } else {
        dispatch({ type: SET_CURRENT_STEP_ERROR, payload: true });
      }
      return;
    }

    if (action.type === STEP_NEXT && currentStepIndex <= maxStepIndex) {
      nextStepIndex = currentStepIndex + 1;
      checkValidation = true;
    }

    if (action.type === STEP_BACK && currentStepIndex > minStepIndex) {
      nextStepIndex = currentStepIndex - 1;
    }
    
    if (nextStepIndex === 1 && !addressError && !force && !addressEditFlag) {
      nextStepIndex =
        action.type === STEP_BACK ? nextStepIndex - 1 : nextStepIndex + 1;
    }

    if(nextStepIndex === 2 && sellerType !== 'C'){
      nextStepIndex = action.type === STEP_BACK ? nextStepIndex - 1 : nextStepIndex + 1;
    }

    if (nextStepIndex === 1 && !addressError && !force && !addressEditFlag) {
      nextStepIndex =
        action.type === STEP_BACK ? nextStepIndex - 1 : nextStepIndex + 1;
    }

    if (nextStepIndex > maxStepIndex) nextStepIndex = maxStepIndex;

    if (nextStepIndex < minStepIndex) nextStepIndex = minStepIndex;

    determineNextStep(
      currentStepIndex,
      nextStepIndex,
      checkValidation,
      prevState,
      dispatch
    );
  }
};
const determineNextStep = (
  currentStepIndex,
  nextStepIndex,
  checkValidation,
  prevState,
  dispatch
) => {
  if (currentStepIndex === 0 || !checkValidation) {
    dispatch({ type: GOTO_STEP, payload: nextStepIndex });
    return;
  }
  dispatch({ type: SET_CURRENT_STEP_ERROR, payload: true });

  if (currentStepIndex === 1) {
    let newState = checkRequiredFields(currentStepIndex, prevState, dispatch);
    if (!newState) {
      return;
    }
  }
  if (currentStepIndex === 2) {
    let newState = checkRequiredFields(currentStepIndex, prevState, dispatch);
    if (!newState) {
      return;
    }
    if(prevState.pickupForm.fields.isOwnerTitle.value !== 'Y' || prevState.pickupForm.fields.titleClear.value !== 'Y' || prevState.pickupForm.fields.isTitleAvailable.value !== 'Y'){
      dispatch({ type: PICKUP_FROM_SUBMISSION, payload: newState });
    }
    //dispatch pickup details form
  }
  if (currentStepIndex === 3) {
    let newState = checkRequiredFields(currentStepIndex, prevState, dispatch);
    if (!newState) {
      return;
    }

    dispatch({ type: PICKUP_FROM_SUBMISSION, payload: newState });
  }

  if(currentStepIndex === prevState.lot.totalSteps - 1) {
    dispatch({ type: PICKUP_FROM_SUBMISSION});
  }

  dispatch({ type: SET_CURRENT_STEP_ERROR, payload: false });
  dispatch({ type: GOTO_STEP, payload: nextStepIndex });
  return;
};

const checkRequiredFields = (currentStepIndex, prevState, dispatch) => {
  let activeStepFields = steps.find(
    step => step.stepIndex === currentStepIndex
  );
  let fields = prevState.pickupForm.fields;
  return !activeStepFields.stepFields.find(
    f => fields[f.name].error && fields[f.name].readable
  );
};

const checkAddressRequiredFields = (currentStepIndex, prevState, dispatch) => {
  let activeStep = steps.find(step => step.stepIndex === currentStepIndex);
  let fields = prevState.address.pickupAddress;
  let convertAddressFieldsToPickForm = mapObject(fields, (val, key) => {
    return { value: val };
  });
  let errors = {};
  activeStep.stepFields.map(stepField => {
    if (stepField.required && fields[stepField.name] === "") {
      errors[stepField.name] = "this field is required";
    }
  });

  if (Object.keys(errors).length > 0) {
    dispatch({ type: SET_ADDRESS_ERRORS, payload: errors });
    return false;
  }
  dispatch({
    type: SET_ADDRESS_TO_PICKUPFORM,
    payload: convertAddressFieldsToPickForm
  });
  return true;
};



// WEBPACK FOOTER //
// ./src/redux/middleware/stepper.js